import { render, staticRenderFns } from "./ClassOverview.vue?vue&type=template&id=28ef03be&scoped=true"
import script from "./ClassOverview.vue?vue&type=script&lang=js"
export * from "./ClassOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ef03be",
  null
  
)

export default component.exports